// ============================================================================
// AppointmentStatusBadge — подпись и цвет статуса записи (SSoT статусов —
// перечисления сервера; тон/признак активности — общий маппинг lib).
// ============================================================================

import { statusMeta, statusToneClass, type AppointmentItem } from '@/lib/medicAppointments';

export interface AppointmentStatusBadgeProps {
  item: AppointmentItem;
  labels?: Record<string, string>;
  className?: string;
}

export function AppointmentStatusBadge({ item, labels, className = '' }: AppointmentStatusBadgeProps) {
  const meta = statusMeta(item.source, item.statusCode, labels);
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full border px-2 py-0.5 text-[10px] ${statusToneClass(meta.tone)} ${className}`}
      title={item.statusCode ? `Код статуса: ${item.statusCode}` : 'Статус не указан'}
    >
      {meta.label}
    </span>
  );
}
